function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import React, { Component } from 'react';
import { Route, withRouter, Switch } from 'react-router-dom';
import StepsIndicator from '../StepsIndicator/StepsIndicator';
import s from './onBoardingWrapper.scss';
import OnboardingLayout from '../OnBoardingLayout/OnboardingLayout';
import { TransitionGroup } from 'react-transition-group';
import FadeUp from '../../animations/fadeUp';
import Fade from '../../animations/fade';
export var OnBoardingWrapper = /*#__PURE__*/function (_Component) {
  _inheritsLoose(OnBoardingWrapper, _Component);

  function OnBoardingWrapper() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = OnBoardingWrapper.prototype;

  _proto.emptycall = function emptycall() {};

  _proto.render = function render() {
    var _this$props = this.props,
        location = _this$props.location,
        onBoardingDescriptor = _this$props.onBoardingDescriptor,
        goToRoute = _this$props.goToRoute,
        wixLogoLink = _this$props.wixLogoLink,
        inBizMgr = _this$props.inBizMgr,
        _this$props$bng = _this$props.bng,
        bng = _this$props$bng === void 0 ? false : _this$props$bng,
        _this$props$hideIndic = _this$props.hideIndicator,
        hideIndicator = _this$props$hideIndic === void 0 ? false : _this$props$hideIndic,
        isMobile = _this$props.isMobile;
    var pathname = location.pathname;
    var showTitle = true;
    var selectedIndex = 0;
    var title = '';
    var subTitle = '';
    var onBordingDescriptor = onBoardingDescriptor;
    var routesMap = onBoardingDescriptor.map(function (descriptor, i) {
      if (descriptor.path === pathname) {
        selectedIndex = i;
        title = descriptor.title;
        subTitle = descriptor.subTitle;
      }

      return /*#__PURE__*/React.createElement(Route, {
        exact: true,
        key: descriptor.key,
        path: descriptor.path,
        component: descriptor.route
      });
    });

    if (title === '') {
      showTitle = false;
    }

    var stepIndicator = null;

    if (!hideIndicator) {
      stepIndicator = /*#__PURE__*/React.createElement(StepsIndicator, {
        onStepClick: function onStepClick(step, index) {
          return index < selectedIndex && goToRoute(step.path);
        },
        currentIndex: selectedIndex,
        steps: onBordingDescriptor.filter(function (item) {
          return !item.isHidden;
        }).map(function (descriptor, i) {
          return _objectSpread(_objectSpread({}, descriptor), {}, {
            clickable: i < selectedIndex
          });
        })
      });
    }

    return /*#__PURE__*/React.createElement(OnboardingLayout, {
      showHeader: showTitle,
      stepsIndicatorComponent: !hideIndicator && /*#__PURE__*/React.createElement(TransitionGroup, null, /*#__PURE__*/React.createElement(FadeUp, null, stepIndicator)),
      contentComponent: /*#__PURE__*/React.createElement(TransitionGroup, null, /*#__PURE__*/React.createElement(Fade, {
        noTranslate: true,
        delay: 200,
        key: "/"
      }, /*#__PURE__*/React.createElement(Switch, {
        path: pathname
      }, routesMap))),
      titleKey: title,
      subTitleKey: subTitle,
      stepsClass: s.stepsContainer,
      titleClass: s.title,
      subTitleClass: s.subTitle,
      wixLogoLink: wixLogoLink,
      inBizMgr: inBizMgr,
      bng: bng,
      isMobile: isMobile
    });
  };

  return OnBoardingWrapper;
}(Component);
export var OnBoardingWrapperWithRouter = withRouter(function (props) {
  return /*#__PURE__*/React.createElement(OnBoardingWrapper, props);
});